import axios from './BaseService';

const AUTOBOT_URL = `${process.env.REACT_APP_API_URL}/autobot`;

// The master auto-trading bot. One bot orchestrates the TODAY / RISK / FUTURES
// engines under a single budget + daily-cap.
//
// getAutoBot() returns:
//   { config:{ enabled, mode:'PAPER'|'LIVE', baseCurrency:'USDC', budgetPerTrade,
//              maxTradesPerDay, maxConcurrent, useToday, useRisk, useFutures,
//              riskLevel:'SAFE'|'MEDIUM'|'AGGRESSIVE', leverage, tradesToday,
//              tradeDay, status, lastMessage },
//     managed:[{ engine:'TODAY'|'RISK'|'FUTURES', symbol, mode, pnl, openEntry, currentPrice }],
//     planned:[{ symbol, strategy, reason }],
//     freeBalance }
export async function getAutoBot() {
    const response = await axios.get(AUTOBOT_URL);
    return response.data;
}

// PATCH partial config fields; returns the updated config object.
export async function updateAutoBot(cfg) {
    const response = await axios.patch(AUTOBOT_URL, cfg);
    return response.data;
}

export async function startAutoBot() {
    const response = await axios.post(`${AUTOBOT_URL}/start`, null);
    return response.data;
}

export async function stopAutoBot() {
    const response = await axios.post(`${AUTOBOT_URL}/stop`, null);
    return response.data;
}
